<button app-round-button mat-dialog-close class="mb-4">
    <fa-icon icon="chevron-right"></fa-icon>
</button>
<app-loading *ngIf="loading$ | async"></app-loading>

<ng-container *ngIf="sharepointObject$ | async as object">
    <div class="preview-wrapper">
        <ng-container *ngIf="object.ThumbnailUrl; else noImage">
            <div class="no-image" *ngIf="!thumbnailIsLoaded">
                <app-loading></app-loading>
            </div>
            <img class="full-screen-image" [class.hide]="!thumbnailIsLoaded" [src]="object.ThumbnailUrl" (load)="thumbnailIsLoaded = true"  alt="Vorschau des Dokuments"/>
        </ng-container>
        <a [href]="object.Url" target="_blank" app-round-button matTooltip="in Sharepoint öffnen" class="sharepoint-btn">
            <fa-icon icon="arrow-up-right-from-square"></fa-icon>
        </a>
    </div>
    <app-detail-list-template class="w-full" [Data]="sharepointObjectDetails$ | async" [Editing]="false" [Inline]="true"></app-detail-list-template>
<!--    <table>-->
<!--        <tr *ngFor="let k of Object.keys(object)">-->
<!--            <td>{{k}}</td>-->
<!--            <td>{{object[k]}}</td>-->
<!--        </tr>-->
<!--    </table>-->
    <ng-template #noImage>
        <div class="no-image">
            <fa-icon [icon]="object.IsFolder ? 'folder' : 'file'" size="5x"></fa-icon>
        </div>
    </ng-template>
</ng-container>
<div *ngIf="(loading$ | async) === false && !(sharepointObject$ | async)"> Objekt konnte nicht gefunden werden</div>

